<header class="site-header" [class.scrolled]="isScrolled" [class.nav-hidden]="isHidden"
    [class.header-transparent]="!isScrolled && isHome()">
    @if (showAnnouncement()) {
    <div class="announcement-bar" role="region" aria-label="Announcement">
        <div class="container-xxl d-flex justify-content-between align-items-center">
            <div class="announcement-content">
                <span class="announcement-badge">2026 INSIGHTS</span>
                <span class="announcement-text">Explore Articix AI Automation & Enterprise Cloud Transformation
                    Solutions</span>
                <a routerLink="/ai-automation" class="announcement-link">
                    Discover AI Frameworks <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </a>
            </div>
            <button type="button" class="announcement-dismiss" (click)="dismissAnnouncement($event)"
                aria-label="Dismiss announcement">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
        </div>
    </div>
    }

    <div class="container-xxl">
        <nav class="navbar navbar-expand-lg corporate-navbar" aria-label="Primary navigation">
            <a routerLink="/" class="navbar-brand brand-mark" aria-label="Articix home link"
                (click)="closeMobileMenu()">
                <img src="assets/logo/Articix-Transparent-BG.png" class="home-header-logo" alt="Articix logo" width="76"
                    height="76">
            </a>

            <!-- Mobile Actions -->
            <div class="mobile-actions d-lg-none">
                <button class="mobile-search-trigger" (click)="openSearchOverlay()" aria-label="Open search modal">
                    <i class="fa-solid fa-magnifying-glass"></i>
                </button>
                <button class="mobile-menu-toggle" type="button" [class.is-open]="isMobileMenuOpen"
                    (click)="toggleMobileMenu()" [attr.aria-expanded]="isMobileMenuOpen"
                    aria-controls="mobile-menu-overlay" aria-label="Toggle mobile navigation menu">
                    <span class="hamburger-line"></span>
                    <span class="hamburger-line"></span>
                    <span class="hamburger-line"></span>
                </button>
            </div>

            <!-- Desktop Navigation -->
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <div class="navbar-nav ms-auto align-items-lg-center">
                    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                        class="nav-item nav-link linkscrolltotop">Home</a>
                    <a routerLink="/what-we-do" routerLinkActive="active" class="nav-item nav-link linkscrolltotop">What
                        We Do</a>
                    <a routerLink="/industries" routerLinkActive="active"
                        class="nav-item nav-link linkscrolltotop">Industries</a>

                    <div class="nav-item dropdown megamenu-dropdown">
                        <a class="nav-link dropdown-toggle linkscrolltotop" href="#" role="button"
                            data-bs-toggle="dropdown" [class.active]="isInsightsSectionActive()" aria-expanded="false">
                            Insights
                        </a>
                        <div class="dropdown-menu megamenu-panel insights-megamenu">
                            <div class="megamenu-grid-2">
                                <div class="megamenu-col">
                                    <h5 class="megamenu-title">Research & Analysis</h5>
                                    <ul class="megamenu-list">
                                        <li><a class="dropdown-item" routerLink="/insights"><i
                                                    class="fa-solid fa-lightbulb"></i> All Insights</a></li>
                                        <li><a class="dropdown-item" routerLink="/insights/global-studies"><i
                                                    class="fa-solid fa-book-open"></i> Global Studies</a></li>
                                        <li><a class="dropdown-item" routerLink="/insights/analyst-recognition"><i
                                                    class="fa-solid fa-chart-simple"></i> Analyst Recognition</a></li>
                                    </ul>
                                </div>
                                <div class="megamenu-col">
                                    <h5 class="megamenu-title">Success Stories</h5>
                                    <ul class="megamenu-list">
                                        <li><a class="dropdown-item" routerLink="/insights/customer-stories"><i
                                                    class="fa-solid fa-handshake"></i> Customer Stories</a></li>
                                        <li><a class="dropdown-item" routerLink="/responsible-ai"><i
                                                    class="fa-solid fa-shield-halved"></i> Responsible AI</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="nav-item dropdown megamenu-dropdown">
                        <a class="nav-link dropdown-toggle linkscrolltotop" href="#" role="button"
                            data-bs-toggle="dropdown" [class.active]="isCompanySectionActive()" aria-expanded="false">
                            Company
                        </a>
                        <div class="dropdown-menu megamenu-panel company-megamenu">
                            <div class="megamenu-grid-3">
                                <div class="megamenu-col">
                                    <h5 class="megamenu-title">About Us</h5>
                                    <ul class="megamenu-list">
                                        <li><a class="dropdown-item" routerLink="/who-we-are"><i
                                                    class="fa-solid fa-circle-info"></i> Who We Are</a></li>
                                        <li><a class="dropdown-item" routerLink="/company/leadership"><i
                                                    class="fa-solid fa-users"></i> Leadership</a></li>
                                        <li><a class="dropdown-item" routerLink="/company/values"><i
                                                    class="fa-solid fa-scale-balanced"></i> Core Values</a></li>
                                        <li><a class="dropdown-item" routerLink="/company/brand"><i
                                                    class="fa-solid fa-palette"></i> Brand Guidelines</a></li>
                                    </ul>
                                </div>
                                <div class="megamenu-col">
                                    <h5 class="megamenu-title">Responsibility</h5>
                                    <ul class="megamenu-list">
                                        <li><a class="dropdown-item" routerLink="/company/inclusion"><i
                                                    class="fa-solid fa-universal-access"></i> Inclusion</a></li>
                                        <li><a class="dropdown-item" routerLink="/company/community"><i
                                                    class="fa-solid fa-people-group"></i> Community</a></li>
                                        <li><a class="dropdown-item" routerLink="/company/sustainability"><i
                                                    class="fa-solid fa-leaf"></i> Sustainability</a></li>
                                        <li><a class="dropdown-item" routerLink="/investor-relations"><i
                                                    class="fa-solid fa-chart-line"></i> Investor Relations</a></li>
                                    </ul>
                                </div>
                                <div class="megamenu-col">
                                    <h5 class="megamenu-title">Updates & Careers</h5>
                                    <ul class="megamenu-list">
                                        <li><a class="dropdown-item" routerLink="/company/newsroom"><i
                                                    class="fa-solid fa-newspaper"></i> Newsroom</a></li>
                                        <li><a class="dropdown-item" routerLink="/company/press"><i
                                                    class="fa-solid fa-microphone"></i> Press Center</a></li>
                                        <li><a class="dropdown-item" routerLink="/company/events"><i
                                                    class="fa-solid fa-calendar-days"></i> Corporate Events</a></li>
                                        <li><a class="dropdown-item" routerLink="/careers"><i
                                                    class="fa-solid fa-briefcase"></i> Careers</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <a routerLink="/contact" routerLinkActive="active"
                        class="nav-item nav-link linkscrolltotop">Contact</a>
                </div>

                <div class="nav-extra-actions">
                    <button class="nav-search-btn" (click)="openSearchOverlay()" aria-label="Open search modal">
                        <i class="fa-solid fa-magnifying-glass"></i>
                    </button>
                    <a routerLink="/contact" class="btn btn-premium-nav linkscrolltotop">Schedule a consultation</a>
                </div>
            </div>
        </nav>
    </div>
</header>

<!-- Mobile Full-Screen Navigation Drawer -->
<div class="mobile-menu-overlay" id="mobile-menu-overlay" [class.is-open]="isMobileMenuOpen" role="dialog"
    aria-modal="true" aria-label="Mobile Navigation Menu">
    <div class="mobile-menu-backdrop" (click)="closeMobileMenu()"></div>
    <div class="mobile-menu-panel">
        <div class="mobile-menu-header">
            <img src="assets/logo/Articix-Transparent-BG.png" alt="Articix logo" width="40" height="40"
                class="mobile-brand-logo">
            <button class="mobile-menu-close" (click)="closeMobileMenu()" aria-label="Close mobile menu">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>

        <nav class="mobile-menu-nav" aria-label="Mobile navigation links">
            <a routerLink="/" class="mobile-menu-link" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }" (click)="closeMobileMenu()">
                <span class="mobile-link-text">Home</span>
                <i class="fa-solid fa-chevron-right mobile-link-arrow"></i>
            </a>
            <a routerLink="/what-we-do" class="mobile-menu-link" routerLinkActive="active" (click)="closeMobileMenu()">
                <span class="mobile-link-text">What We Do</span>
                <i class="fa-solid fa-chevron-right mobile-link-arrow"></i>
            </a>
            <a routerLink="/industries" class="mobile-menu-link" routerLinkActive="active" (click)="closeMobileMenu()">
                <span class="mobile-link-text">Industries</span>
                <i class="fa-solid fa-chevron-right mobile-link-arrow"></i>
            </a>

            <!-- Insights Accordion Group -->
            <button type="button" class="mobile-menu-link mobile-menu-group-toggle"
                [class.is-expanded]="isInsightsExpanded" [attr.aria-expanded]="isInsightsExpanded"
                (click)="toggleInsightsSubmenu()">
                <span class="mobile-link-text">Insights</span>
                <i class="fa-solid fa-chevron-down mobile-link-arrow"></i>
            </button>
            @if (isInsightsExpanded) {
            <div class="mobile-submenu">
                <a routerLink="/insights" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">All Insights</a>
                <a routerLink="/insights/customer-stories" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Customer Stories</a>
                <a routerLink="/insights/global-studies" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Global Studies</a>
                <a routerLink="/insights/analyst-recognition" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Analyst Recognition</a>
            </div>
            }

            <!-- Company Accordion Group -->
            <button type="button" class="mobile-menu-link mobile-menu-group-toggle"
                [class.is-expanded]="isCompanyExpanded" [attr.aria-expanded]="isCompanyExpanded"
                (click)="toggleCompanySubmenu()">
                <span class="mobile-link-text">Company</span>
                <i class="fa-solid fa-chevron-down mobile-link-arrow"></i>
            </button>
            @if (isCompanyExpanded) {
            <div class="mobile-submenu">
                <a routerLink="/who-we-are" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Who We Are</a>
                <a routerLink="/company/leadership" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Leadership</a>
                <a routerLink="/company/values" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Values</a>
                <a routerLink="/company/inclusion" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Inclusion</a>
                <a routerLink="/company/community" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Community</a>
                <a routerLink="/company/sustainability" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Sustainability</a>
                <a routerLink="/company/brand" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Brand Guidelines</a>
                <a routerLink="/investor-relations" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Investor Relations</a>
                <a routerLink="/company/newsroom" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Newsroom</a>
                <a routerLink="/company/press" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Press & Media</a>
                <a routerLink="/company/events" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Corporate Events</a>
                <a routerLink="/careers" class="mobile-submenu-link" routerLinkActive="active"
                    (click)="closeMobileMenu()">Careers</a>
            </div>
            }

            <a routerLink="/contact" class="mobile-menu-link" routerLinkActive="active" (click)="closeMobileMenu()">
                <span class="mobile-link-text">Contact</span>
                <i class="fa-solid fa-chevron-right mobile-link-arrow"></i>
            </a>
        </nav>

        <div class="mobile-menu-footer">
            <a routerLink="/contact" class="btn btn-brand-primary mobile-menu-cta" (click)="closeMobileMenu()">
                Schedule a consultation
            </a>
            <div class="mobile-menu-contact">
                <span><i class="fa-solid fa-envelope"></i> contact&#64;articix.com</span>
                <span><i class="fa-solid fa-phone"></i> +91 7560987816</span>
            </div>
        </div>
    </div>
</div>

<!-- Full-Screen Search Modal Overlay -->
<div class="search-overlay" [class.is-open]="isSearchOverlayOpen" role="dialog" aria-modal="true"
    aria-label="Search site content">
    <div class="search-overlay-backdrop" (click)="closeSearchOverlay()"></div>
    <div class="search-overlay-container">
        <div class="search-overlay-header">
            <div class="container-xxl d-flex justify-content-between align-items-center">
                <img src="assets/logo/Articix-Transparent-BG.png" alt="Articix logo" width="50" height="50"
                    class="overlay-logo">
                <button class="search-overlay-close" (click)="closeSearchOverlay()" aria-label="Close search overlay">
                    <span class="close-text">CLOSE</span>
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
        </div>

        <div class="search-overlay-content">
            <div class="container">
                <div class="search-input-group">
                    <i class="fa-solid fa-magnifying-glass search-main-icon"></i>
                    <input type="text" class="search-overlay-input"
                        placeholder="Search for services, insights, or careers..." [value]="searchTerm"
                        (input)="onSearchInput($event)" aria-label="Search content keywords">
                    <div class="input-focus-line"></div>
                </div>

                <div class="search-results-wrapper">
                    @if (debouncedSearchTerm.trim().length >= 2) {
                    @if (searchResults.length > 0) {
                    <div class="results-grid" role="listbox" aria-label="Search results">
                        <h3 class="results-label">Top Results ({{ searchResults.length }})</h3>
                        @for (page of searchResults; track page.id; let idx = $index) {
                        <button class="search-result-card" [class.keyboard-active]="idx === activeResultIndex"
                            (click)="navigateFromSearch(page)">
                            <div class="result-info" style="width: 100%;">
                                <span class="result-title" style="display: flex; align-items: center; gap: 8px;">
                                    <i class="fa-solid" [class]="getTypeIcon(page.pageType)"
                                        style="color: var(--brand-teal); font-size: 16px; min-width: 20px;"></i>
                                    <span [innerHTML]="page.highlightedTitle || page.title"></span>
                                </span>
                                <span class="result-path"
                                    style="display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-top: 4px; opacity: 0.8; font-size: 12px;">
                                    <span
                                        style="background: rgba(95, 181, 200, 0.15); color: var(--brand-teal); padding: 2px 8px; border-radius: 4px; font-weight: 600; font-size: 10px; text-transform: uppercase; font-family: var(--font-family-body);">
                                        {{ page.pageType }}
                                    </span>
                                    @if (page.section) {
                                    <span style="color: rgba(255, 255, 255, 0.5);">in</span>
                                    <span style="color: #fff; font-weight: 500;">{{ page.section }}</span>
                                    }
                                </span>
                                @if (page.description) {
                                <span class="result-path"
                                    style="margin-top: 6px; font-family: var(--font-family-body); line-height: 1.4; color: rgba(255, 255, 255, 0.75); display: block; font-weight: 400; white-space: normal; text-transform: none;"
                                    [innerHTML]="page.highlightedDescription || page.description"></span>
                                }
                                <span class="result-path" style="margin-top: 4px; display: block;">{{ page.route
                                    }}</span>
                            </div>
                            <i class="fa-solid fa-arrow-right result-arrow"></i>
                        </button>
                        }
                    </div>
                    } @else {
                    <div class="no-results">
                        <i class="fa-solid fa-circle-info"></i>
                        <p>No results found for "<strong>{{ searchTerm }}</strong>"</p>
                        <span>Try searching for 'Cloud', 'AI', 'Consulting', or 'Leadership'</span>
                    </div>
                    }
                    } @else if (searchTerm.trim().length > 0) {
                    <div class="no-results" style="padding: 30px 0;">
                        <p style="font-size: 16px; opacity: 0.8;">Keep typing...</p>
                    </div>
                    } @else {
                    <div class="quick-links">
                        <h3 class="results-label">Quick Links</h3>
                        <div class="quick-links-grid">
                            <button (click)="navigateFromSearch('/what-we-do')" class="quick-link-item">What We
                                Do</button>
                            <button (click)="navigateFromSearch('/insights')" class="quick-link-item">Insights</button>
                            <button (click)="navigateFromSearch('/careers')" class="quick-link-item">Careers</button>
                            <button (click)="navigateFromSearch('/contact')" class="quick-link-item">Contact Us</button>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>